export const DEFAULT_ERROR_MESSAGE = 'Unable to complete authentication.';
export const AUTH_REDIRECT_SUCCESS_MESSAGE = 'Authentication redirect handled.';

export const AUTH_REDIRECT_ENDPOINTS = {
  authByToken: '/sso/authByToken',
  getAuthToken: '/sso/authenticate/getAuthToken',
  initSession: '/session/init?from_web2=true',
  logout: '/logout',
};
